import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { BaseComponent } from '../base.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { addInputValue, getDataFromInput, getFieldInputFilter, getForm, MonthOptions } from './advanced-filter.const';
import { Observable } from 'rxjs';
import { UserService } from '../../common/services/User.service';
import { TicketService } from '../../common/services/Ticket.service';
import { FieldService } from '../../common/services/Field.service';
import { ServiceService } from '../../common/services/Service.service';
import { CampaignService } from '../../common/services/Campaign.service';
import { PriorityService } from '../../common/services/Priority.service';
import { TicketTypeService } from '../../common/services/TicketType.service';
import { GroupService } from '../../common/services/Group.service';
import * as _ from 'lodash';
import { EvsAddressService } from '../../common/services/EvsAddress.service';
import { OrganizeService } from '../../common/services/Organize.service';
import { FormFieldConst, FormFieldType } from '../modals/modal-form-template/modal-form.const';
import { SearchService } from '../../common/services/Search.service';
import { CommentService } from '../../common/services/Comment.service';
import { UploadService } from '../../common/services/Upload.service';
import { CommonService } from '../../common/services/Common.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { CommonSettingsService } from '../../common/share-data/common.setting.service';
import { SharedUserService } from '../../common/share-data/user.service';

@Component({
  selector: 'app-advanced-filter-component',
  templateUrl: './advanced-filter.component.html',
  styleUrls: ['./advanced-filter.component.css'],
  providers: [
    UserService,
    TicketService,
    EvsAddressService,
    OrganizeService,
    GroupService,
    FieldService,
    SearchService,
    CommentService,
    UploadService,
    CommonService,
    CampaignService,
    ServiceService,
    PriorityService,
    TicketTypeService,
  ],
})
export class AdvancedFilterComponent extends BaseComponent implements OnChanges {
  @Input() isFooter = true;
  @Input() hideFields: string[] = [];
  @Input() type = 'ticket';
  @Input() modal = 'search';
  @Input() selectFilter: any = {};
  @Input() filterModal: any = {
    main_and_or: 'and',
    sub_and_or: 'and',
  };
  @Input() formKey = 'ticket_search';
  @Input() isCreate = false;
  @Input() shouldSubmit = false;
  @Output() onSubmitFilter: any = new EventEmitter();
  @Output() onClosed: any = new EventEmitter();
  @Output() endLoading: any = new EventEmitter();

  public fields: any = [];
  protected choice: any = [];
  protected allStatus: any = [];
  protected allAgents: any = [];
  protected allCampaigns: any = [];
  protected allGroups: any = [];
  protected allPriorities: any = [];
  protected allTypes: any = [];
  protected allCities: any = [];
  protected allOrganizes: any = [];
  protected months: any[] = MonthOptions;
  protected readonly FormFieldType = FormFieldType;
  protected readonly FormFieldConst = FormFieldConst;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private sharedCommonSettings: CommonSettingsService,
    private sharedUserService: SharedUserService
  ) {
    super(changeDetector, toastr, modalService);
  }

  // tslint:disable-next-line:use-life-cycle-interface
  async ngOnInit() {
    this.is_loading = true;
    this.model = {
      name: '',
      main_and_or: 'and',
      sub_and_or: 'and',
    };
    if (this.type === 'ticket') {
      await this.initTicket();
    } else if (this.type === 'user') {
      await this.initUser();
    }
  }

  async initUser() {
    await this.initOrganizes();
    await this.initAllAgents();
    await this.initCustomerGroups();
    await this.initCities();
    await this.initCampaigns();
    await this.initUserFields();
    this.fields.forEach(e => {
      this.choice[e.key] = false;
    });
    this.is_loading = false;
    this.endLoading.emit(true);
  }

  async initTicket() {
    await this.initStatusTicket();
    await this.initServices();
    await this.initPriorities();
    await this.initTypes();
    await this.initAllAgents();
    await this.initUserGroups();
    await this.initCampaigns();
    await this.initTicketFields();
    this.fields.forEach(e => {
      this.choice[e.key] = false;
    });
    this.is_loading = false;
    this.endLoading.emit(true);
  }

  generateSubmitTitle() {
    switch (this.modal) {
      case 'search':
        return 'Tìm kiếm';
      case 'create':
        return 'Tạo mới';
        break;
      case 'step':
        return 'Tiếp';
        break;
      default:
        return 'Tạo mới';
        break;
    }
  }

  async initStatusTicket() {
    const res = await this.sharedCommonSettings.getAllStatus();
    const statusList = [];
    res.forEach((c: any) => {
      statusList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allStatus = statusList;
  }

  async initAllAgents() {
    const res = await this.sharedUserService.getAllUsers();
    const agentList = [];
    res.forEach((c: any) => {
      agentList.push({
        text: c.name,
        id: c._id,
      });
    });
    this.allAgents = agentList;
  }

  async initCampaigns() {
    const res = await this.sharedCommonSettings.getAllCampaign();
    const campaign_list = [];
    res.forEach((c: any) => {
      campaign_list.push({
        text: c.name,
        id: c._id,
      });
    });
    this.allCampaigns = campaign_list;
  }

  async initUserGroups() {
    const res = await this.sharedUserService.getUserGroups();
    const groupList = [];
    res.forEach((c: any) => {
      groupList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allGroups = groupList;
  }
  async initCustomerGroups() {
    const res = await this.sharedUserService.getCustomerGroups();
    const groupList = [];
    res.forEach((c: any) => {
      groupList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allGroups = groupList;
  }

  async initPriorities() {
    const res = await this.sharedCommonSettings.getAllPriority();
    const priorityList = [];
    res.forEach((c: any) => {
      priorityList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allPriorities = priorityList;
  }

  async initTypes() {
    const res = await this.sharedCommonSettings.getAllType();
    const typeList = [];
    res.forEach((c: any) => {
      typeList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allTypes = typeList;
  }

  async initCities() {
    const res = await this.sharedCommonSettings.getAllCities();
    const cityList = [];
    res.forEach((c: any) => {
      cityList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allCities = cityList;
  }

  async initOrganizes() {
    const res = await this.sharedCommonSettings.getAllOrganize();
    const organizeList = [];
    res.forEach((c: any) => {
      organizeList.push({
        text: c.name,
        id: c.organize_id,
      });
    });
    this.allOrganizes = organizeList;
  }

  async initServices() {
    const res = await this.sharedCommonSettings.getAllService();
    const lstServices = this.getSortedService(res);
    lstServices.forEach(service => {
      this.fields.push({
        key: service.field,
        title: 'Nhóm dịch vụ cấp ' + (service.order + 1),
        type: 'select',
        data: JSON.stringify(service.list),
      });
    });
  }
  async initUserFields() {
    this.fields = [
      { key: 'name', title: 'Tên', type: 'text' },
      { key: 'phone', title: 'Điện thoại', type: 'text' },
      { key: 'dob', title: 'Ngày sinh', type: 'date' },
      { key: 'email', title: 'Email', type: 'text' },
      { key: 'facebook', title: 'Facebook', type: 'text' },
      { key: 'address', title: 'Địa chỉ', type: 'text' },
      {
        key: 'city_id',
        title: 'Thành phố',
        type: 'select',
        data: JSON.stringify(this.allCities),
        data_type: '_number',
      },
      {
        key: 'dob_month',
        title: 'Tháng sinh',
        type: 'select',
        data: JSON.stringify(this.months),
        data_type: '_number',
      },
      {
        key: 'group_id',
        title: 'Nhóm khách hàng',
        type: 'select',
        data: JSON.stringify(this.allGroups),
        data_type: '_number',
      },
      {
        key: 'organize_id',
        title: 'Tổ chức',
        type: 'select',
        data: JSON.stringify(this.allOrganizes),
        data_type: '_number',
      },
      {
        key: 'customer_type',
        title: 'Hạng khách hàng',
        type: 'select',
        data: JSON.stringify([
          { id: '0', text: 'Thường' },
          { id: '1', text: 'Bạc' },
          { id: '2', text: 'Vàng' },
          { id: '3', text: 'Kim cương' },
        ]),
      },
      {
        key: 'gender',
        title: 'Giới tính',
        type: 'select',
        data: JSON.stringify([
          { id: 'male', text: 'Nam giới' },
          { id: 'female', text: 'Nữ giới' },
          { id: 'other', text: 'Khác' },
        ]),
      },
      { key: 'note', title: 'Ghi chú', type: 'text' },
      { key: 'created_at', title: 'Ngày khởi tạo', type: 'date' },
      { key: 'updated_at', title: 'Ngày cập nhật', type: 'date' },
    ];
    const res = await this.sharedCommonSettings.getAllUserFields();
    res.forEach(field => {
      let _type;
      if (field.type === 'select' || field.type === 'multi-select') {
        _type = 'select';
      } else if (field.type === 'textarea') {
        _type = 'text';
      } else {
        _type = field.type;
      }
      const tmp = {
        key: field.key,
        title: field.title,
        type: _type,
      };
      if (tmp.type === 'select') {
        let data = field.data || [];
        data = _.map(data, d => {
          return {
            id: d,
            text: d,
          };
        });
        tmp['data'] = JSON.stringify(data);
      }
      this.fields.push(tmp);
    });
  }
  async initTicketFields() {
    this.fields = [
      { key: 'code', title: 'Mã ticket', type: 'text' },
      {
        key: 'campaign_id',
        title: 'Chiến dịch',
        type: 'select',
        data: JSON.stringify(this.allCampaigns),
      },
      {
        key: 'status',
        title: 'Trạng thái',
        type: 'select',
        data: JSON.stringify(this.allStatus),
        data_type: 'number',
      },
      {
        key: 'priority_id',
        title: 'Độ ưu tiên',
        type: 'select',
        data: JSON.stringify(this.allPriorities),
        data_type: 'number',
      },
      {
        key: 'type_id',
        title: 'Loại ticket',
        type: 'select',
        data: JSON.stringify(this.allTypes),
        data_type: 'number',
      },
      {
        key: 'group_id',
        title: 'Bộ phận',
        type: 'select',
        data: JSON.stringify(this.allGroups),
        data_type: 'number',
      },
      { key: 'call_id', title: 'Mã cuộc gọi', type: 'text' },
      {
        key: 'call_status',
        title: 'Trạng thái trả lời',
        type: 'select',
        data: JSON.stringify([
          { id: 'answer', text: 'Trả lời' },
          { id: 'reject', text: 'Từ chối' },
          { id: 'miss', text: 'Nhỡ' },
        ]),
      },
      {
        key: 'source_detail',
        title: 'Nguồn khởi tạo',
        type: 'select',
        data: JSON.stringify([
          { id: 'hand', text: 'Thêm mới' },
          { id: 'call_inbound', text: 'Khách gọi tới' },
          { id: 'call_outbound', text: 'Gọi điện ra' },
          { id: 'chat', text: 'Chat' },
          { id: 'email', text: 'Kênh Email' },
          { id: 'facebook', text: 'Kênh Facebook' },
          { id: 'zalo', text: 'Zalo' },
        ]),
      },
      {
        key: 'finisher',
        title: 'Đối tượng kết thúc',
        type: 'select',
        data: JSON.stringify([
          { id: 'agent', text: 'Chuyên viên' },
          { id: 'end_user', text: 'Khách hàng' },
        ]),
      },
      {
        key: 'receiver_id',
        title: 'Người tiếp nhận',
        type: 'select',
        data: JSON.stringify(this.allAgents),
      },
      {
        key: 'assign_agent_id',
        title: 'Người xử lý',
        type: 'select',
        data: JSON.stringify(this.allAgents),
      },
      { key: 'subject', title: 'Tiêu đề', type: 'text' },
      { key: 'time_start', title: 'Thời gian bắt đầu', type: 'date' },
      { key: 'time_end', title: 'Thời gian kết thúc', type: 'date' },
      { key: 'created_at', title: 'Ngày khởi tạo', type: 'date' },
      { key: 'updated_at', title: 'Ngày cập nhật', type: 'date' },
      { key: 'duedate', title: 'Thời hạn xử lý', type: 'date' },
    ];
    const res = await this.sharedCommonSettings.getAllTicketFields();
    res.forEach(field => {
      let _type;
      if (field.type === 'select' || field.type === 'multi-select') {
        _type = 'select';
      } else if (field.type === 'textarea') {
        _type = 'text';
      } else {
        _type = field.type;
      }
      const tmp = {
        key: field.key,
        title: field.title,
        type: _type,
      };
      if (tmp.type === 'select') {
        let data = field.data || [];
        data = _.map(data, d => {
          return {
            id: d,
            text: d,
          };
        });
        tmp['data'] = JSON.stringify(data);
      }
      this.fields.push(tmp);
    });

    if (this.hideFields.length > 0) {
      this.fields = this.fields.filter(e => !this.hideFields.includes(e.key));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectFilter) {
      this.choiceFilter();
    }
  }

  choiceFilter() {
    this.fields.forEach(e => {
      $(`#${this.formKey}-dynamic-${e.key}`).html('');
      this.choice[e.key] = false;
      $(`#${this.formKey}-key-${e.key}`).prop('checked', false).trigger('change');
    });
    this.model.main_and_or = this.filterModal.main_and_or || 'and';
    this.model.sub_and_or = this.filterModal.sub_and_or || 'and';
    if (this.selectFilter) {
      const data_type: any = {};
      this.fields.forEach(e => {
        data_type[e.key] = e.type;
      });
      const keys = Object.keys(this.selectFilter);
      keys.forEach(key => {
        $(`#${this.formKey}-key-${key}`).prop('checked', true).trigger('change');
        this.choice[key] = true;
        const d = this.selectFilter[key];
        let index = 0;
        d.forEach(e => {
          this.addCondition(key, index, data_type[key]);
          const el = $('#' + this.formKey + '-group-input-' + key + '-' + index + '-' + e.label);
          el.find('input:radio').prop('checked', true).trigger('change');
          const value = data_type[key] === 'date' ? moment(e.val).format('DD-MM-YYYY').toString() : e.val;
          $('#' + this.formKey + '-value-' + key + '-' + index + '-' + e.label)
            .val(value)
            .trigger('change');
          index++;
        });
      });
    }
    this.onSubmit();
  }

  getSortedService(lstServices) {
    const serviceList = [
      {
        field: 'service_id',
        list: [{ id: '', text: '', parent_id: '' }],
        order: 0,
      },
    ];
    lstServices.forEach((c: any) => {
      if (c.parent_id) {
        let order = -1;
        for (let i = 0; i < serviceList.length; i++) {
          if (order != -1) {
            break;
          }
          for (let j = 0; j < serviceList[i].list.length; j++) {
            const service = serviceList[i].list[j];
            if (service.id == c.parent_id) {
              order = i + 1;
              break;
            }
          }
        }
        if (!serviceList[order]) {
          serviceList[order] = {
            field: 'service_id' + order,
            order: order,
            list: [
              {
                text: c.name,
                id: c.id,
                parent_id: c.parent_id,
              },
            ],
          };
        } else {
          serviceList[order].list.push({
            text: c.name,
            id: c.id,
            parent_id: c.parent_id,
          });
        }
      } else {
        serviceList[0].list.push({
          text: c.name,
          id: c.id,
          parent_id: '',
        });
      }
    });
    return serviceList;
  }

  changedSubAndOr() {
    let text = 'Hoặc';
    if (this.model.sub_and_or == 'and') {
      text = 'Và';
    }
    $('.and-or').html(text);
  }

  choiceKey(key, type) {
    const valueKey = $(`#${this.formKey}-key-${key}`).is(':checked');
    this.choice[key] = valueKey;
    if (valueKey) {
      this.addCondition(key, 0, type);
    } else {
      $('#' + this.formKey + '-dynamic-' + key).html('');
    }
  }

  addMore(key, type) {
    const last = $(`#${this.formKey}-dynamic-${key}`).find('.condition-value:last');
    const lastNumber = Number(last.data('index'));
    const number = (isNaN(lastNumber) ? 0 : lastNumber) + 1;
    this.addCondition(key, number, type);
  }

  addCondition(key, index, type) {
    let close_margin = '0px';
    if (index != 0) {
      close_margin = '-20px';
    }
    let eHtml = '';
    eHtml +=
      `<div class="condition-value mb-5" style="background: #74727229; margin-left: 16px; border-radius: 3px; padding:10px"
                  id="${this.formKey}-box-${key}-${index}"
                  data-index="` +
      index +
      `"> `;
    if (index > 0) {
      if (this.model.sub_and_or == 'and') {
        eHtml += `<span class="and-or" style="border: 1px solid #d6d6d6;background: white;border-radius: 10px;margin-left: 100px;z-index: 10;text-align: center;display: block;width: 50px;">Và</span>`;
      } else {
        eHtml += `<span class="and-or" style="border: 1px solid #d6d6d6;background: white;border-radius: 10px;margin-left: 100px;z-index: 10;text-align: center;display: block;width: 50px;">Hoặc</span>`;
      }
    }
    eHtml +=
      `<a class="btn-close" id="btn-close-` +
      index +
      `"
                  href="javascript:closeBox('` +
      key +
      `',` +
      index +
      `,'` +
      this.formKey +
      `')">
                <i class="icon fa fa-close" style="float: right;margin-top: ` +
      close_margin +
      `"></i>
              </a> `;
    eHtml += getFieldInputFilter(type, key, index, this.formKey);
    eHtml += `</div>`;
    $(`#${this.formKey}-dynamic-${key}`).append(eHtml);
  }

  onSubmit() {
    const [data, active_fields] = getDataFromInput(this.formKey);
    const save_data = getForm(this.formKey);
    const formData = {
      data_search: data,
      data_save: save_data,
      active_fields: active_fields,
      name: this.model.name,
      main_and_or: this.model.main_and_or,
      sub_and_or: this.model.sub_and_or,
    };
    this.onSubmitFilter.emit({ data: formData });
  }

  onClose() {
    this.onClosed.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/advanced-filter/advanced-filter.component.ts